import {Outlet} from 'react-router-dom';
import logo from '../../../images/logo2.svg'; // with import


const LoginLayout = () => {
    return (
        <div className='bg-gray-300 w-full h-full flex justify-center items-center min-h-screen'>
            <div className='bg-white w-full max-w-md   p-4 rounded-md shadow-2xl'>
                <div className='flex justify-center py-10'><img className='w-64' src={logo} alt=""/></div>
                <Outlet/>

            </div>
        </div>
    );
};

export default LoginLayout;